import React, { useEffect, useState } from "react";
import { RadioButton } from "@kompare/kompare-ui-library";
import { Flex } from 'src/components';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  options: RadioOption[];
  value?: string;
  onChange?: (selectedOption: string, isValid: boolean) => void;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ options, value,  onChange }) => {

  const [selectedOption, setSelectedOption] = useState<string | undefined>(value);

  useEffect(() => {
    setSelectedOption(value);
  }
  , [value]);

  // Funkcija za ažuriranje stanja
  const handleOptionChange = (optionValue: string) => {
    setSelectedOption(optionValue);
    if (onChange) onChange(optionValue, true); // Pozivamo onChange prop funkciju sa izabranom opcijom
  };

  return (
    <Flex vertical gap={20}>
      {options.map((option) => (
        <RadioButton key={option.value} value={option.value} label={option.label} checked={selectedOption === option.value} onChange={() => handleOptionChange(option.value)} />
      ))}
    </Flex>
  );
}
